(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["skx-product-cro"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeStickyButtons = (root = document) => {
      root.querySelectorAll('[data-skx-sticky]').forEach((sticky) => {
        if (sticky.dataset.skxReady === 'true') return;
        sticky.dataset.skxReady = 'true';

        const stickyButton = sticky.querySelector('[data-skx-submit]');
        const stickyPrice = sticky.querySelector('[data-skx-price]');
        const mainProduct = sticky.closest('[id^="MainProduct-"]') || document.querySelector('[id^="MainProduct-"]');
        if (!stickyButton || !mainProduct) return;

        const primaryButton = () => mainProduct.querySelector('product-form .product-form__submit');

        const currentPrice = () => {
          const candidates = Array.from(
            mainProduct.querySelectorAll(
              '.price__sale .price-item--sale, .price__regular .price-item--regular'
            )
          );
          return candidates.find((candidate) => candidate.offsetParent !== null && candidate.textContent.trim());
        };

        const localizedPrice = (value) => {
          const compact = value.replace(/\s+/g, ' ').trim();
          const amount = compact.replace(/\bKM\b/gi, '').replace(/([,.])00\b/, '').trim();
          return `${amount} KM`;
        };

        const sync = () => {
          const primary = primaryButton();
          if (!primary) {
            sticky.classList.remove('is-visible');
            sticky.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('skx-sticky-visible');
            return;
          }

          const unavailable =
            primary.disabled ||
            primary.getAttribute('aria-disabled') === 'true';
          const passedPrimaryButton = primary.getBoundingClientRect().bottom < 0;
          const isMobile = window.matchMedia('(max-width: 749px)').matches;
          const show = isMobile && passedPrimaryButton && !unavailable;
          const price = currentPrice();

          stickyButton.disabled = unavailable;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          document.body.classList.toggle('skx-sticky-visible', show);

          if (price && stickyPrice) {
            const nextPrice = localizedPrice(price.textContent);
            if (stickyPrice.textContent.trim() !== nextPrice) {
              stickyPrice.textContent = nextPrice;
            }
          }
        };

        let frame;
        const scheduleSync = () => {
          if (frame) return;
          frame = window.requestAnimationFrame(() => {
            frame = null;
            sync();
          });
        };

        stickyButton.addEventListener('click', () => {
          const primary = primaryButton();
          if (primary && !primary.disabled && primary.getAttribute('aria-disabled') !== 'true') {
            primary.click();
          }
        });

        window.addEventListener('scroll', scheduleSync, { passive: true });
        window.addEventListener('resize', scheduleSync, { passive: true });
        document.addEventListener('change', () => {
          window.setTimeout(sync, 0);
          window.setTimeout(sync, 500);
        });

        sync();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeStickyButtons(), { once: true });
    } else {
      initializeStickyButtons();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeStickyButtons(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
